import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    pendingApprovalPatternId: null,
}

const patternSlice = createSlice({
    name: 'pattern',
    initialState,
    reducers: {
        setPendingApprovalPatternId: (state, action) => {
            state.pendingApprovalPatternId = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const patternActions = patternSlice.actions
export const { setPendingApprovalPatternId, reset } = patternSlice.actions

export default patternSlice.reducer
